import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimit/slot-game/bin/flowcontrol/FlowStateController";
import {NineToFive} from "../NineToFive";
import {gsap} from "gsap";
import {NineToFiveSound} from "../sound/NineToFiveSound";
import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DoXNudge} from "../runnerpresentations/maingame/DoXNudge";
import {RevealWilds} from "../runnerpresentations/maingame/RevealWilds";
import {RevealXWays} from "../runnerpresentations/maingame/RevealXWays";
import {FreeSpinFires} from "../runnerpresentations/freespin/FreeSpinFires";
import {FreeSpinLawsuits} from "../runnerpresentations/freespin/FreeSpinLawsuits";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {NormalWin} from "../runnerpresentations/maingame/win/NormalWin";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {NoWin} from "../runnerpresentations/maingame/NoWin";
import {FreeSpinOvertime} from "../runnerpresentations/freespin/FreeSpinOvertime";
import {FreeSpinsIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {FreeSpinUpgrade} from "../runnerpresentations/freespin/FreeSpinUpgrade";
import {FreeSpinsOutro} from "../runnerpresentations/freespin/FreesSpinOutro";

export class NineToFiveFreespinsIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const presentations:SimplePresentation[] = [
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.restorePadding(controller),
                                  ()=>{return true},
                                  "restorePadding"),
            new FreeSpinsIntro(),
            new FreeSpinUpgrade(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreespinZeroBet(controller),
                                  ()=>{return true},
                                  "doFreespinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Fs intro runner ");

    }

    private restorePadding(controller:SimplePresentationRunnerController) {
       gsap.timeline().add(() => {}).add(() => controller.finish(), '>0.5');
    }

    private doFreespinZeroBet(controller:SimplePresentationRunnerController) {
        const tl = gsap.timeline();
        tl.add(() => {
            NineToFive.apiPlugin.betHandler.zeroBet();
            NineToFive.keypadPlugin.setZeroBetSpinCounter(NineToFive.model.data.freespinsLeft-1);
        });
        tl.add(() => {
            NineToFive.soundPlayer.playLoopingSound(NineToFiveSound.REEL_SPINNING);
        });
        //NineToFive.baseGameReelView.getAllSymbolsActually()
        //    .filter(sym => sym.reelPosition == -1)
        //    .forEach(sym => sym.visible = true);
        NineToFive.baseGameReelView.reelModels.map((reel) => reel.enableXNudge());
        NineToFive.baseGameReelView.reelModels.forEach((reel, index) => tl.add(reel.start(), `${0.14*index}`));

        tl.add(() => { controller.finish() });
    }
}